<!-- Container Block Template -->
@if (currentContainerStructure(); as structure) {
  @if (structure.type === 'flex') {
    <!-- Flex Container -->
    <div
      class="container-block flex-container"
      [ngStyle]="{
        'display': 'flex',
        'flex-direction': structure.direction || 'row',
        'justify-content': flexJustifyContent(),
        'align-items': flexAlignItems(),
        'flex-wrap': structure.wrap ? 'wrap' : 'nowrap',
        'gap': gapValue(),
        'max-width': maxWidth(),
        'padding-top': paddingTop(),
        'padding-bottom': paddingBottom(),
        'padding-left': paddingLeft(),
        'padding-right': paddingRight(),
        'margin-top': marginTop(),
        'margin-bottom': marginBottom(),
        'margin-left': contentAlignment()?.marginLeft || marginLeft(),
        'margin-right': contentAlignment()?.marginRight || marginRight(),
      }"
    >
      <!-- Default content projection -->
      <ng-content></ng-content>

      <!-- Block rendering if blocks are provided -->
      @if (hasBlocks()) {
        <app-block-list [blockIdList]="containerBlocks()?.blocks ?? []"></app-block-list>
      }
    </div>
  } @else if (structure.type === 'grid' || structure.type === 'subgrid') {
    <!-- Grid Container -->
    <div
      class="container-block grid-container"
      [ngStyle]="{
        'display': structure.type === 'subgrid' ? 'subgrid' : 'grid',
        'grid-template-columns':
          structure.columns && structure.columns > 0
            ? 'repeat(' + structure.columns + ', 1fr)'
            : null,
        'grid-template-rows':
          structure.rows && structure.rows > 0 ? 'repeat(' + structure.rows + ', auto)' : null,
        'gap': gapValue(),
        'max-width': maxWidth(),
        'padding-top': paddingTop(),
        'padding-bottom': paddingBottom(),
        'padding-left': paddingLeft(),
        'padding-right': paddingRight(),
        'margin-top': marginTop(),
        'margin-bottom': marginBottom(),
        'margin-left': contentAlignment()?.marginLeft || marginLeft(),
        'margin-right': contentAlignment()?.marginRight || marginRight(),
      }"
    >
      <!-- Default content projection -->
      <ng-content></ng-content>

      <!-- Block rendering if blocks are provided -->
      @if (hasBlocks()) {
        <app-block-list [blockIdList]="containerBlocks()?.blocks ?? []"></app-block-list>
      }
    </div>
  } @else if (structure.type === 'block') {
    <!-- Block Container -->
    <div
      class="container-block block-container"
      [ngStyle]="{
        'display': 'block',
        'max-width': maxWidth(),
        'padding-top': paddingTop(),
        'padding-bottom': paddingBottom(),
        'padding-left': paddingLeft(),
        'padding-right': paddingRight(),
        'margin-top': marginTop(),
        'margin-bottom': marginBottom(),
        'margin-left': contentAlignment()?.marginLeft || marginLeft(),
        'margin-right': contentAlignment()?.marginRight || marginRight(),
        '--vertical-space': blockVerticalSpace(),
      }"
    >
      <!-- Default content projection -->
      <ng-content></ng-content>

      <!-- Block rendering if blocks are provided -->
      @if (hasBlocks()) {
        <app-block-list
          class="force-vertical-layout"
          [blockIdList]="containerBlocks()?.blocks ?? []"
          [ngStyle]="{
            'display': 'block',
            'width': '100%',
            '--item-margin-bottom': blockVerticalSpace(),
          }"
        ></app-block-list>
      }
    </div>
  }
} @else {
  <!-- Default Container when no structure is defined -->
  <div
    class="container-block container-default"
    [ngStyle]="{
      'display': 'block',
      'max-width': maxWidth(),
      'margin-left': contentAlignment()?.marginLeft || 'auto',
      'margin-right': contentAlignment()?.marginRight || 'auto',
    }"
  >
    <!-- Default content projection -->
    <ng-content></ng-content>

    <!-- Block rendering if blocks are provided -->
    @if (hasBlocks()) {
      <app-block-list [blockIdList]="containerBlocks()?.blocks ?? []"></app-block-list>
    }
  </div>
}
